<mat-card class="card">
  <ix-icon class="icon" name="mdi-widgets"></ix-icon>
  <div class="message">{{ message() }}</div>
</mat-card>
